import React, { useState } from "react";
import { Table } from "components/ui";
import { ROLES_PERMS_HEADERS } from "../enums";
import CreateRoleButton from "../buttons/CreateRoleButton/CreateRoleButton";
import RolesAndPermissionsModals from "./RolesAndPermissionsModals/RolesAndPermissionsModals";
import RolesAndPermissionsDropdown from "./RolesAndPermissionsDropdown/RolesAndPermissionsDropdown";
import RoleUserCount from "./RoleUserCount/RoleUserCount";
import PaginationSearch from "components/ui/InputTypes/InputSearch/PaginationSearch/PaginationSearch";
import RolesAccessControl from "../RolesAccessControl/RolesAccessControl";
import { SmartTime } from "utils/helper";
import "./RolesAndPermissionsContent.scss";

const RolesAndPermissionsContent = ({
    roles,
    handleSuccess,
    tableIsLoading,
    errorMssg,
    handleSearch,
    searchIsLoading,
    clearSearch,defaultValue
}) => {
    const [currentAction, setCurrentAction] = useState("");
    const [currentRole, setCurrentRole] = useState({});

    const handleActionModal = (action, role) => {
        setCurrentAction(action);
        setCurrentRole(role);
    };

    const closeActionModal = () => {
        setCurrentAction("");
        setCurrentRole("");
    };

    const tableData = roles?.map((role) => ({
        roleName: `${role.displayName}`,
        description: role.roleDescription || "—",
        users: <RoleUserCount count={role.userCount ?? 0} />,
        lastUpdated: role.updatedDate ? SmartTime(role.updatedDate) : "—",
        action: (
            <RolesAndPermissionsDropdown
                role={role}
                handleActionModal={handleActionModal}
            />
        ),
    }));

    return (
        <>
            <div className='role__permission--action'>
                <PaginationSearch
                    handleSearch={handleSearch}
                    placeholder='Search for role name'
                    isLoading={searchIsLoading}
                    clearSearch={clearSearch}
                    defaultValue={defaultValue}
                />
                <RolesAccessControl>
                    <CreateRoleButton handleActionModal={handleActionModal} />
                </RolesAccessControl>
            </div>

            {tableData?.length > 0 && (
                <Table
                    headers={ROLES_PERMS_HEADERS}
                    dataSource={tableData}
                    isLoading={tableIsLoading}
                    hasErrors={Boolean(errorMssg)}
                    tableError={errorMssg}
                />
            )}

            {currentAction && (
                <RolesAndPermissionsModals
                    role={currentRole}
                    currentAction={currentAction}
                    closeModal={closeActionModal}
                    handleSuccess={handleSuccess}
                />
            )}
        </>
    );
};

export default RolesAndPermissionsContent;
